/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["quote-caveats .main-list{padding:0;margin:0}quote-caveats .main-list .main-list-item{list-style:none}"];
export { styles as styles };
